export default __webpack_public_path__ + "static/media/misc-makeupA-480w.17f0af07.png";